










import { Component, Vue, Prop } from 'nuxt-property-decorator';

@Component
export default class ModalImage extends Vue {
  @Prop(String)
  backgroundColor!: string

  @Prop({ type: Object, required: true })
  image!: any
}
